// フィールド名の日本語ラベル。
// 編集フォームと、AIの読み違い（crosscheck）の表示で同じ言葉を使うためにここへ集約する。
export const FIELD_LABELS: Record<string, string> = {
  // 店舗
  store_name: '店名',
  store_company: '会社名',
  store_branch: '店舗名',
  store_tel: '電話番号',
  store_address: '住所',
  store_invoice_no: 'インボイス番号',
  receipt_type: '種別',
  payment_method: '支払方法',
  // 日時
  purchased_at: '購入日時',
  purchased_date: '購入日',
  purchased_time: '購入時刻',
  // 金額
  subtotal: '小計',
  tax_amount: '消費税',
  total_amount: '合計',
  discount_total: '値引き合計',
  stated_item_count: '記載点数',
  paid_amount: 'お預かり',
  change_amount: 'お釣り',
  tax8_target: '8%対象',
  tax8_amount: '8%税額',
  tax10_target: '10%対象',
  tax10_amount: '10%税額',
  notes: 'メモ',
  // 明細
  raw_name: 'レシートの表記',
  name: '商品名',
  generic_name: '一般名',
  category: 'カテゴリ',
  quantity: '数量',
  unit_price: '単価',
  amount: '金額',
  discount: '値引き',
  'items.count': '明細の行数',
  'items.amounts': '明細の金額',
}

const ITEM_FIELD_PATTERN = /^items\[(\d+)\]\.(.+)$/

/**
 * crosscheck が返すフィールド名を日本語にする。
 *
 * `items[2].raw_name` のような明細単位の指摘は行番号付きで示す。
 * 対応表にない名前はそのまま返す（増えたときに空欄になるより分かる）。
 */
export const formatFieldLabel = (fieldName: string): string => {
  const matched = ITEM_FIELD_PATTERN.exec(fieldName)
  if (!matched) return FIELD_LABELS[fieldName] ?? fieldName

  const [, lineNo, field] = matched
  return `${lineNo}行目の${FIELD_LABELS[field] ?? field}`
}
